import LookupAdminItem from "../../../../Domain/LookupAdminItem";
import InputTypesEnum from "../../../../Enums/InputTypesEnum";
import ValidityHelper from "../../../../Helpers/ValidityHelper";
import LookupItemService from "../../../../Services/LookupItemService";

let costGroupOptionsCache = null;

export default class LookupPanelDescription
{
  //-----------------------------------------------------
  //---------------- Fields for General Edit Panel ------
  //-----------------------------------------------------

  static headerForEditPanel = 'Edit Lookup Item';
  static headerForCreatePanel = 'Create Lookup Item';
  static labelForSubmitButton = 'Save';
  static itemType = LookupAdminItem;
  static clickOnSubmitFunction = LookupItemService.PostLookupItem;
  static nameOfTheIdField = 'LookupItemId';

  static generalEditComponentDidMountServiceFunction = () => LookupPanelDescription.loadCostGroupOptions();
  static processResultFromgeneralEditComponentDidMountServiceFunction = (result, editedItem) => editedItem;

  // The following field can be an array or a function that returns an array.
  static fieldsInEditPanel = [
    {
      fieldName: 'Text',
      label: 'Text',
      className: 'col-6',
      type: InputTypesEnum.Text,
      validityChecker: ValidityHelper.forRequiredTextField,
    },
    {
      fieldName: 'Value',
      label: 'Value',
      className: 'col-6',
      type: InputTypesEnum.Text,
      validityChecker: ValidityHelper.forRequiredTextField,
    },
    {
      fieldName: 'Order',
      label: 'Order',
      className: 'col-6',
      type: InputTypesEnum.Number,
      validityChecker: ValidityHelper.AlwaysFlawless,
    },
    {
      fieldName: 'IsActive',
      label: 'IsActive',
      className: 'col-6',
      type: InputTypesEnum.Bool,
      validityChecker: ValidityHelper.forRequiredBoolField,
    },
    {
      fieldName: 'Misc',
      label: 'Cost Group',
      className: 'col-12',
      type: InputTypesEnum.Select,
      options: () => LookupPanelDescription.getSelectOptionsForCostGroup(),
      validityChecker: ValidityHelper.AlwaysFlawless,
      hide: (item) => item.LookupId !== 68,
    },
    {
      fieldName: 'Misc',
      label: LookupPanelDescription.getLabel,
      className: 'col-12',
      type: InputTypesEnum.Text,
      validityChecker: ValidityHelper.AlwaysFlawless,
      hide: (item) => item.LookupId === 68,
    },
  ];

  //-----------------------------------------------------
  //--------- End of Fields for General Edit Panel ------
  //-----------------------------------------------------

  //-----------------------------------------------------
  //---------- Fields for General Edit Wizzard ----------
  //-----------------------------------------------------

  static titleForEdit = 'Edit Lookup Item';
  static titleForCreate = 'Create Lookup Item';
  static serviceFunction = LookupItemService.PostLookupItem;

  static pagesInGeneralEditWizzard = [
    {
      label: 'Lookup Item',
      fields: [
        {
          fieldName: 'Text',
          label: 'Text',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'Value',
          label: 'Value',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'Order',
          label: 'Order',
          className: 'col-6',
          type: InputTypesEnum.Number,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'IsActive',
          label: 'IsActive',
          className: 'col-6',
          type: InputTypesEnum.Bool,
          validityChecker: ValidityHelper.forRequiredBoolField,
        },
        {
          fieldName: 'Misc',
          label: 'Cost Group',
          className: 'col-12',
          type: InputTypesEnum.Select,
          selectvalues: () => LookupPanelDescription.getSelectOptionsForCostGroup(),
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: (item) => item.LookupId !== 68,
        },
        {
          fieldName: 'Misc',
          label: 'Misc',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: (item) => item.LookupId === 68,
        },
      ],
    },
  ];

  //-----------------------------------------------------
  //------ End of Fields for General Edit Wizzard -------
  //-----------------------------------------------------
  static getLabel (item)
  {
    switch (item.LookupId)
    {
      case 108:
        return 'Create PTO entry in timesheet for this type';
      default:
        return 'Misc';
    }
  }

  static async loadCostGroupOptions ()
  {
    if (costGroupOptionsCache) return costGroupOptionsCache;
    const data = await LookupItemService.GetCostGroups();
    costGroupOptionsCache = [
      { label: 'Choose one...', value: '', disabled: true },
      ...data.map((item) => ({ label: item.label, value: item.value, disabled: false })),
    ];
    return costGroupOptionsCache;
  }

  static getSelectOptionsForCostGroup ()
  {
    return costGroupOptionsCache || [ { label: 'Loading...', value: '', disabled: true } ];
  }
}
